import React, { useState, useEffect } from "react";
import Navbar from "../../components/common/Navbar";
import { useHistory } from 'react-router-dom';
import { sendResult } from "../../utils/helper";

// Style
import "./LevelSiete.scss";
import hex from "../../assets/images/level-dos/hexagon.svg";
import One from "../../assets/images/level-siete/One.svg";
import Two from "../../assets/images/level-siete/Two.svg";
import Three from "../../assets/images/level-siete/Three.svg";
import Four from "../../assets/images/level-siete/Four.svg";
import Five from "../../assets/images/level-siete/Five.svg";
import Six from "../../assets/images/level-siete/Six.svg";
import Seven from "../../assets/images/level-siete/Seven.svg";
import Eight from "../../assets/images/level-siete/Eight.svg";
import Nine from "../../assets/images/level-siete/Nine.svg";
import Ten from "../../assets/images/level-siete/Ten.svg";
import Eleven from "../../assets/images/level-siete/Eleven.svg";
import Twelve from "../../assets/images/level-siete/Twelve.svg";
import Thirteen from "../../assets/images/level-siete/Thirteen.svg";
import Fourteen from "../../assets/images/level-siete/Fourteen.svg";
import Fifteen from "../../assets/images/level-siete/Fifteen.svg";
import Sixteen from "../../assets/images/level-siete/Sixteen.svg";
import LevelComplete from "../../components/common/LevelComplete/LevelComplete";

const images = [
  { image: "one", value: 5, icon: One, clicked: false },
  { type: "two", value: 4, icon: Two, clicked: false },
  { type: "three", value: 16, icon: Three, clicked: false },
  { type: "four", value: 9, icon: Four, clicked: false },
  { type: "five", value: 12, icon: Five, clicked: false },
  { type: "six", value: 10, icon: Six, clicked: false },
  { type: "seven", value: 6, icon: Seven, clicked: false },
  { type: "eight", value: 2, icon: Eight, clicked: false },
  { type: "nine", value: 7, icon: Nine, clicked: false },
  { type: "ten", value: 1, icon: Ten, clicked: false },
  { type: "eleven", value: 11, icon: Eleven, clicked: false },
  { type: "twelve", value: 13, icon: Twelve, clicked: false },
  { type: "thirteen", value: 3, icon: Thirteen, clicked: false },
  { type: "fourteen", value: 14, icon: Fourteen, clicked: false },
  { type: "fifteen", value: 8, icon: Fifteen, clicked: false },
  { type: "sixteen", value: 15, icon: Sixteen, clicked: false },
];

function LevelSiete() {
  const history = useHistory();
  const [tiles, setTiles] = useState(images);
  const [lastClicked, setLastClicked] = useState(0);
  const [won, setWon] = useState(false);
  const [move, setMove] = useState(false);
  const [dataPoints, setDataPoints] = useState({
    firstRightClickTime: 0,
    firstThreeRightClicks: 0,
    clicksBeforeThreeRightClicks: 0,
    attemptsBeforeThreeClicks: 0,
    totalTime: 0,
    totalHints: 0,
  });
  const [timer, setTimer] = useState(0);
  const [attempts, setAttempts] = useState(1);
  const [clicks, setClicks] = useState(0);
  const [righClicks, setRightClicks] = useState(0);

  useEffect(() => {
    setTimeout(() => setTimer(timer + 1), 1000);
  }, [timer]);

  const tileClick = (index, value) => {
    setClicks(clicks + 1);
    if (value - lastClicked === 1) {
      if (dataPoints.firstRightClickTime === 0) {
        setDataPoints({
          ...dataPoints,
          firstRightClickTime: timer
        });
      }
      setRightClicks((prevState) => {
        if (prevState + 1 === 3 && dataPoints.firstThreeRightClicks === 0) {
          setDataPoints({
            ...dataPoints,
            clicksBeforeThreeRightClicks: clicks,
            firstThreeRightClicks: timer,
            attemptsBeforeThreeClicks: attempts,
          })
        }
        return prevState + 1
      });
      let newTiles = tiles.map((item, i) => {
        if (index == i) {
          setLastClicked(value);
          return { ...item, clicked: true };
        } else {
          return item;
        }
      });
      setTiles(newTiles);
    } else {
      let newTiles = tiles.map((item, i) => {
        return { ...item, clicked: false };
      });
      setLastClicked(0);
      setAttempts(attempts + 1);
      setTiles(newTiles);
    }
  };

  // Check if won
  useEffect(() => {
    let index = 0;
    while (index < tiles.length) {
      if (tiles[index].clicked === false) {
        setWon(false);
        break;
      }
      index += 1;
    }
    if (index === tiles.length) {
      setWon(true);
      setDataPoints({
        ...dataPoints,
        totalTime: timer,
      })
    }
  }, [lastClicked]);

  // Call won state
  useEffect(() => {
    setTimeout(() => {
      if (won) {
        const finalObj = {
          gameData: {
            levelData: [
              {
                level: 9,
                levelName: 'Edges',
                firstRightClickTime: dataPoints.firstRightClickTime,
                firstThreeRightClicks: dataPoints.firstThreeRightClicks,
                clicksBeforeThreeRightClicks: dataPoints.clicksBeforeThreeRightClicks,
                attemptsBeforeThreeClicks: dataPoints.attemptsBeforeThreeClicks,
                totalTime: timer,
                totalClicks: clicks,
                attempts: attempts,
                isLevelCleared: true,
                isLevelSkipped: false,
                totalHintsTaken: localStorage.getItem("totalHints"),
                timeForFirstHint: localStorage.getItem("totalHints") !== 0 ? localStorage.getItem("hint1") : 0,
                timeForSecondHint: localStorage.getItem("totalHints") !== 0 ? localStorage.getItem("hint2") : 0
              }
            ],
          }
        }
        console.log(finalObj)
        sendResult(finalObj)
        setMove(true);
        console.log(dataPoints, attempts, clicks)
        let levelsDone = Number(localStorage.getItem("levelsDone"))
        localStorage.setItem("levelsDone", levelsDone + 1);
        history.push("/game-end");
      }
    }, 500);
  }, [won]);

  return (
    <div className="component-level-siete">
      {/* {move && <LevelComplete levelNum={8} />} */}
      <Navbar won={won} levelNum={9} />
      <div className="game-container">
        {tiles.map((item, index) => (
          <div key={index} className="tile">
            <div
              className="tile-inside"
              onClick={() => tileClick(index, item.value)}
            >
              {!item.clicked ? (
                <img
                  className={`${item.type}`}
                  src={item.icon}
                  alt={item.type}
                />
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LevelSiete;
